<template>
    <el-dialog :visible.sync="isShow" custom-class="choose-per-dialog" :width="dialogWidth" title="选择部门" append-to-body @closed="cannel">
        <div class="oraWrap flex" v-loading="loading">
            <div class="wrap-left f1" v-loading='loadingState'>
                <div class="search-box">
                    <el-input
                        placeholder="请输入内容"
                        v-model="searchStr" 
                        clearable
                        prefix-icon="el-icon-search"
                        size="small">
                    </el-input>
                    <el-checkbox-group v-model="searchSinglePagePer">
                        <div class="search-show-box" v-if="searchShow" :style="{height: searchBoxHeight + 'px',overflow: 'auto'}" v-loadmore="loadMore">
                            <div class="per-box scroll-box flex bm-ac" v-for="(list, index) in searchData" :key="index">
                                <div class="check-box">
                                    <el-checkbox :label="list" :key="index" @change="checked=>searchPersonChange(checked, list)">{{list.personName}}</el-checkbox>
                                </div>
                                <div class="f1 flex">
                                    <!-- <div class="name">{{list.deptName?list.deptName:list.deptCompany}}</div> -->
                                     <!-- <div class="pic-box"><div class="pic">{{list.personName | picStr}}</div></div> -->
                                    <div class="f1">
                                        <div class="name" v-html="list.deptName"></div>
                                        <div class="job">{{list.deptParent}} - {{list.departManagerName}}</div>
                                    </div> 
                                </div>
                            </div>
                            <div class="load" v-if="loadShow">
                                {{loadtxt}}
                            </div>
                        </div>
                    </el-checkbox-group>
                </div>
                <div class="breadcrumb">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item v-for="(rl,index) in routeList" :key="index" @click.native="toRre(index,rl)">{{rl.name}}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="choose-all" v-if="!isAllCheck">
                     <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" :disabled="isAllCheck" @change="checkedAll">全选</el-checkbox>
                </div>
                <div class="choose-scroll" :style="{height: leftBoxHeight + 'px',overflow: leftBoxOverflow}">
                    <el-checkbox-group v-model="singlePagePer" >
                        <template v-for="(list,index) in tableData">
                            <div class="dept-box scroll-box flex" v-if="list.choosetype == 'dept'" :key="index">
                                 <div class="check-box">
                                    <el-checkbox :label="list.deptId" :key="index" @change="checked=>personChange(checked, list)"></el-checkbox>
                                </div>
                                <div class="f1 dept-name">{{list.deptName}}</div>
                                <div class="next-box" @click="nextGet(list)">
                                    <i></i>
                                    <span>下级</span>
                                </div>
                            </div>
                          
                        </template>
                    </el-checkbox-group>
                </div>
                <div class="bm bm-ac bm-pe previous-next-btn" v-if="isUpDownPage">
                    <el-button @click="previousStep"  size="small">{{ btntexts.length > 0 ? btntexts[0] : '上一步'}}</el-button>
                    <el-button type="primary" @click="nextStep" size="small">{{ btntexts.length > 0 ? btntexts[1] : '下一步'}}</el-button>
                </div>
				<!-- v2.0 从设备过来，有下一步的按钮 -->
				<div class="bm bm-ac bm-pe previous-next-btn" v-if="isFromDeviceFill">
                    <el-button type="primary" @click="nextStepDevice" size="small">下一步</el-button>
				</div>
            </div>
            <div class="wrap-right f1" v-if="infinite">
                <div class="choosed-box">
                    <div class="choosed-txt">已选：</div>
                    <div class="choosed-show" :style="{height: rightBoxHeight + 'px',overflow: 'auto'}">
                        <div class="cshow-box" v-for="per in showPer" :key="per.personId">
                            <div class="flex">
                                <div class="f1 cshow-box-l">
                                    <div class="name"></div>
                                    <div class="pername"  v-html="per.deptName"></div>
                                    <div class="deptname">{{per.departManagerName}}</div>
                                </div>
                                <div class="del">
                                    <div class="el-icon-close del-btn" @click="del(per)"></div>
                                </div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="choosed-btn-box">
                        <el-button size="small" @click="cannel">取消</el-button>
                        <el-button size="small" type="danger" @click="callback">确认<span v-if="showPer.length > 0">({{showPer.length}})</span></el-button>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
// const R = require('ramda')
import  '@/utils/loadMore.js';
import { orgApi } from "@/services";
import { resolve } from 'path';
export default {
    name: "choose-dept",
    props: {
        //是否展示框
        showDialog: {
            type: Boolean
        },
        //选择中的名单
        section: {
            type: Array,
            default: () => {
                return [];
            }
        },
        //是否单选 还是多选
        infinite: {
            type: Boolean,
            default: true
        },
        //是否有上下页面
        isUpDownPage: {
            type: Boolean,
            default: true
		},
		// v2.0 定位到登录人所在的部门
		personDeptInfo: {
            type: Object,
            default: () => ({}),
		},
		// v2.0 按钮名字，财务反馈--填报部门进来
		btntexts: {
            type: Array,
            default: () => {
                return [];
            }
        },
    },
    data () {
        return {
            loading: false,
            isShow: this.showDialog,
            checkAll: false,
            isIndeterminate: false,
            searchShow: false,
            searchStr: '',
            routeList: [{ 'id': '', 'name': '正大天晴' }],
            tableData: [],
            searchData: [],
            checkedPer: [],
            singlePagePer: [],//单选 选中的
            singleDeptObj:{},
            searchSinglePagePer: [],//查询 选中的
            showPer: [],
            perArr: [],
            searchPerArr: [],
            leftBoxHeight: 0,
            rightBoxHeight: 0,
            searchBoxHeight: 0,
            leftBoxOverflow: 'auto',
            timeoutId: null,
            page: 1,
            pageTotals: 0,
            loadtxt: '加载中...',
            loadShow: false,
            form:{
                keywordType:0,
                searchKeyword:"all",
			},
			flag: false, // v2.0
        };
    },
    mounted () {
       	console.log(this.searchData.length)
        //获取数据列表
        this.getList('');
        //设置框的高度
        this.setHeight();
		let that = this;
	
    },
    methods: {
        previousStep(){
            this.$emit('handlePreviousStep', "");
        },
        nextStep(){
			if( !R.isEmpty(this.singleDeptObj) ){
				let departName = this.singleDeptObj.deptName,str='';
				if( departName.indexOf("<span>") != -1  ){
					str = departName.replace(/<span>/g,'') // '/g'是全文匹配
				}
				if( str.indexOf("</span>") != -1  ){
					this.singleDeptObj.deptName = str.replace(/<\/span>/g,'')
				}
				this.$emit('callback', {
                    show: false,
                    res: this.singleDeptObj
                });
                this.resetData();
            }else{
                this.$message.error('请选择部门');
            }
            
		},
		// v2.0 设备单选下一步
		nextStepDevice(){
			this.$confirm('是否确认当前部门为设备购入部门?', '提示', {
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$emit('callback', {
                    show: false,
                    res: this.singleDeptObj
                });
                this.resetData();
			}).catch(() => { });
		},
        //获取列表
		getList(opt) {
			this.loading = true;
			let that = this;
			return orgApi.getAllDept(opt).then((res) => {
				let data = res.responseData[0];
				that.perArr = [];
				let arrD = [];
				let	arrP = [];
				
				data.deptList.forEach((value) => {
					value.choosetype = 'dept';
					arrD.push(value);
					that.perArr.push(value);
				});
				//入参不全着补齐
				that.section.forEach((item,index) => {
					arrD.forEach((value) => {
						if(item.deptId == value.deptId){
							that.section[index] = value;
						}
					});
				});
				that.tableData = arrD;
				if(opt == '' && !this.infinite){
					that.section.forEach(res => {
						if (R.findIndex(R.propEq('deptId', res.deptId))(this.checkedPer) == -1) {
							// this.personChange(true, res);
							that.checkedPer.push(res);
							this.singleDeptObj = that.section[0]
							that.singlePagePer.push(res.deptId);
						}
					});
				}
			})
			.catch(e => {
			})
			.finally(() => {
				if ( !this.flag ) {
					this.loading = false;
				}
				this.personShow();
			});
			
		},
		//搜索结果
		getSearch(opt) {
			orgApi.getDepartment(opt)
				.then((res) => {
					let data = res.responseData;
					if (this.page == 1) {
						this.searchData = [];
						this.searchPerArr = [];
						this.page = 1;
						this.pageTotals = 0;
					}
					if (data.total == 0) {
						this.loadShow = true;
						this.loadtxt = '暂无数据';
					} else if (data.totalPages == 1) {
						this.loadShow = false;
					} else {
						this.loadShow = true;
						this.loadtxt = '加载中...';
					}
					this.pageTotals = data.totalPages;
					let arrP = [];
					data.deptList
					this.searchData = this.searchData.concat(data.deptList);

					this.loadSign = true;
					this.page++;
				})
				.catch(e => {
					this.searchShow = false;
					this.leftBoxOverflow = 'auto';
				})
				.finally(() => {
					this.searchShow = true;
					this.leftBoxOverflow = 'hidden';
				});
		},
		//下一层级人员
		nextGet (obj) {
			this.routeList.push({ 'id': obj.deptId, 'name': obj.deptName });
			this.checkAll = false;
			this.isIndeterminate = false;
			this.singlePagePer = [];
			return this.getList(obj.deptId);
		},
		//点击导航
		toRre (index, row) {
			// v2.0 从设备过来，不能让用户回到一级部门
			if (index === 0 && this.isFromDeviceFill) {
				return
			}
			this.routeList.splice(index + 1, this.routeList.length - index);
			this.getList(row.id);
			// this.getList();
			this.checkAll = false;
			this.isIndeterminate = false;
			this.singlePagePer = [];
		},
		//删除人员
		del (json) {
			let index = R.findIndex(R.propEq('deptId', json.deptId))(this.checkedPer);
			let indexPer = R.findIndex(R.propEq('deptId', json.deptId))(this.singlePagePer);
			this.checkedPer.splice(index, 1);
			if (indexPer != -1) {
				this.singlePagePer.splice(indexPer, 1);
			}
			let checkedCount = this.singlePagePer.length;
			this.checkAll = checkedCount === this.perArr.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.perArr.length;
		},
		//设置高度
		setHeight () {
			let windowHeight = document.documentElement.clientHeight;
			let wheight1 = windowHeight / 2 - 60;//左
			let wheight2 = windowHeight / 2 - 20;//右
			let wheight3 = windowHeight / 2 + 55;//查询
			this.leftBoxHeight = wheight1;
			this.rightBoxHeight = wheight2;
			if (this.infinite) {
				this.searchBoxHeight = wheight3;
			} else {
				this.searchBoxHeight = wheight3 - 59;
			}

			window.onresize = () => {
				this.setHeight();
			};
		},
		//当前页面全选
		checkedAll (val) {
			if (val) {
				console.log("checkedPer", this.perArr, this.singlePagePer)
				this.perArr.forEach(res => {
					console.log(R.findIndex(R.propEq('deptId', res.deptId))(this.singlePagePer))
					if (R.findIndex(R.propEq('deptId', res.deptId))(this.singlePagePer) == -1) {
						this.singlePagePer.push(res.deptId);
					}
				});
				this.filterPerson(this.perArr, true, 'add');
			} else {
				this.singlePagePer = [];
				this.filterPerson(this.perArr, true, 'del');
			}
			this.isIndeterminate = false;
		},
		//选择人员
		personChange (checked, value) {
			console.log(this.isUpDownPage);
			if (this.infinite) {
				if (checked) {
					this.filterPerson(value, false, 'add');
				} else {
					this.filterPerson(value, false, 'del');
				}
				let checkedCount = this.singlePagePer.length;
				this.checkAll = checkedCount === this.perArr.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.perArr.length;   
			}else if(!this.infinite && this.isUpDownPage){
				this.singlePagePer = [];
				this.singleDeptObj = {};
				this.singleDeptObj = value;//选中的对象
				this.singlePagePer.push(value.deptId);//选中id
			} else {
				// v2.0 从设备页面进入
				if (this.isFromDeviceFill) {
					this.singlePagePer = []
					this.singleDeptObj = {}
					this.singlePagePer.push(value.deptId)
					this.singleDeptObj = value
					return
				}
				let departName = value.deptName,str='';
				if( departName.indexOf("<span>") != -1  ){
					str = departName.replace(/<span>/g,'') // '/g'是全文匹配
				}
				if( str.indexOf("</span>") != -1  ){
					value.deptName = str.replace(/<\/span>/g,'')
				}
				this.$emit('callback', {
					show: false,
					res: value
				});
				this.resetData();
			}
		},
		//过滤
		filterPerson (arr, isAll, type) {
			if (isAll) {
				if (type == 'add') {
					arr.forEach((res, x) => {
						if ( R.findIndex(R.propEq('deptId', res.deptId))(this.checkedPer) == -1) {
							this.checkedPer.push(res);
						}
					});
				} else if (type == 'del') {
					arr.forEach((res, x) => {
						if (R.findIndex(R.propEq('deptId', res.deptId))(this.checkedPer) > -1) {
							this.checkedPer.splice(R.findIndex(R.propEq('deptId', res.deptId))(this.checkedPer), 1);
						}
					});
				}
			} else if (!isAll) {
				if (type == 'add') {
					if (R.findIndex(R.propEq('deptId', arr.deptId))(this.checkedPer) == -1) {
						this.checkedPer.push(arr);
					}
				} else if (type == 'del') {
					this.checkedPer.splice(R.findIndex(R.propEq('deptId', arr.deptId))(this.checkedPer), 1);
				}
			}
		},
		//人员信息展示
		personShow () {
			this.perArr.forEach((res, i) => {
				this.checkedPer.forEach((val, x) => {
					// console.log(res,val);
					if (res.deptId != val.deptId) {
						this.singlePagePer.push(val.deptId);
					}
				});
			});
			let checkedCount = this.singlePagePer.length;
			this.checkAll = checkedCount === this.perArr.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.perArr.length;
		},
		//搜索选择
		searchPersonChange (checked, value) {
			if (this.infinite) {
				if (checked) {
					if (R.findIndex(R.propEq('deptId', value.deptId))(this.checkedPer) == -1) {
						this.checkedPer.push(value);
					}
					if (R.findIndex(R.propEq('deptId', value.deptId))(this.perArr)> -1) {
						this.singlePagePer.push(value);
					}
				} else {
					if ( R.findIndex(R.propEq('deptId', value.deptId))(this.checkedPer) > -1) {
						this.checkedPer.splice(R.findIndex(R.propEq('deptId', value.deptId))(this.checkedPer), 1);
					}
					if (R.findIndex(R.propEq('deptId', value.deptId))(this.perArr) > -1) {
						this.singlePagePer.splice(R.findIndex(R.propEq('deptId', value.deptId))(this.singlePagePer), 1);
					}
				}
				let checkedCount = this.singlePagePer.length;
				this.checkAll = checkedCount === this.perArr.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.perArr.length;
			}else if(!this.infinite && this.isUpDownPage){
				this.searchSinglePagePer = [];
				this.searchSinglePagePer[0] = value;
				this.singlePagePer = [];
				this.singleDeptObj = {};
				this.singleDeptObj = value;//选中的对象
				this.singlePagePer.push(value.deptId);//选中id
			} else {
				let departName = value.deptName,str='';
				if( departName.indexOf("<span>") != -1  ){
					str = departName.replace(/<span>/g,'') // '/g'是全文匹配
				}
				if( str.indexOf("</span>") != -1  ){
					value.deptName = str.replace(/<\/span>/g,'')
				}
				this.$emit('callback', {
					show: false,
					res: value
				});
				this.resetData();
			}
		},
		//搜索列表
		searchFunc (val) {
			let _this = this;
			clearTimeout(this.timeoutId);
			this.timeoutId = setTimeout(() => {
				_this.page = 1;
				_this.getSearch({ deptName: encodeURI(val), pageNo: _this.page });
			}, 1000);
		},
		//取消选择框
		cannel () {
			this.resetData();
			this.$emit('cannel', false);
		},
		//确认回调
		callback () {
			let departName = this.showPer.deptName,str='';
			if( departName.indexOf("<span>") != -1  ){
				str = departName.replace(/<span>/g,'') // '/g'是全文匹配
			}
			if( str.indexOf("</span>") != -1  ){
				this.showPer.deptName = str.replace(/<\/span>/g,'')
			}
			this.$emit('callback', {
				show: false,
				res: this.showPer
			});
			this.resetData();
		},
		//重置选择框
		resetData () {
			this.loading = false;
			this.isShow = this.showDialog;
			this.checkAll = false;
			this.isIndeterminate = false;
			this.searchShow = false;
			this.searchStr = '';
			this.routeList = [{ 'id': '', 'name': '正大天晴' }];
			this.tableData = [];
			this.searchData = [];
			this.checkedPer = [];
			this.singlePagePer = [];
			this.searchSinglePagePer = [];
			this.showPer = [];
			this.perArr = [];
			this.searchPerArr = [];
			this.leftBoxOverflow = 'auto';
			this.timeoutId = null;
			this.page = 1;
			this.pageTotals = 0;
			this.loadtxt = '加载中...';
			this.loadShow = false;
		},
		//跟多
		loadMore() {
			if (this.loadSign) {
				this.loadSign = false;
				if (this.page > this.pageTotals) {
					this.loadtxt = '没有数据了!';
					return;
				}
				setTimeout(() => {
					this.getSearch({ deptName: encodeURI(this.searchStr), pageNo: this.page });
				}, 1000);
			}
		}
	},
	watch: {
		//默认选择的人员
		checkedPer (val) {
			let arr = [];
			val.forEach(res => {
				arr.push(res);
			});
			this.showPer = arr;
		},
		//打开框
		showDialog (newValue,oldValue) {
			console.log("检测变化的数据",newValue);
			if (newValue) {
				this.flag = this.isFromDeviceFill
				this.getList('').then((res) => {
					// v2.0 定位到登录人所在的部门
					if ( this.isFromDeviceFill ) {
						let { organizationCode , secondDeptCode} = this.personDeptInfo
						let obj = this.perArr.find((item) => item.deptCode === organizationCode)
						// 触发点击事件
						this.nextGet(obj).then(()=> {
							this.flag = false
							this.loading = false;
							let o = this.perArr.find((item) => item.deptCode === secondDeptCode)
							this.singlePagePer = []
							this.singleDeptObj = {}
							this.singlePagePer.push(o.deptId)
							this.singleDeptObj = o
						})
					}

				});
			}
			this.isShow = newValue;
		},
		//查询
		searchStr (val) {
			if (val != '') {
				this.searchFunc(val);
				this.searchSinglePagePer = this.checkedPer;
			} else {
				setTimeout(() => {
					this.searchShow = false;
					this.leftBoxOverflow = 'auto';
					this.searchSinglePagePer = [];
				}, 1000);
			}
		},
		//外部传入选中人员
		section (val) {
			let that = this;
			val.forEach(res => {
				if (R.findIndex(R.propEq('deptId', res.deptId))(this.checkedPer) == -1) {
					// this.personChange(true, res);
					that.checkedPer.push(res);
				}
			});
			
		}
	},
	//文字头像
	filters: {
		picStr (str) {
			return str.substring(str.length - 2);
		}
	},
	computed: {
		//未知代码
		loadingState: function() {
		//   return this.$store.state.organize.loginRequesting
		},
		//弹框宽度
		dialogWidth () {
			if (this.infinite) {
				return 725 + 'px';
			} else {
				return (725 / 2) + 'px';
			}
		},
		//多选就打开全选功能 单选就不打开
		isAllCheck () {
			if (this.infinite) {
				return false;
			} else {
				return true;
			}
		},
		// v2.0 判断是否是从设备页面过来
		isFromDeviceFill(){
			return JSON.stringify(this.personDeptInfo) != "{}"
		}
	}
};
</script>
	<style lang="scss" scoped>
	.flex{
		display: flex;
	}
	.f1{
		flex: 1;
	}
	.bm-ac {
		align-items:center;
	}
	.bm-pc {
		justify-content: center;
	}
	.clear{
		clear: both;
	}
	.oraWrap{
		border-top: 1px solid #e8e9ed;
		line-height: 100%;
		width: 100%;
		.wrap-left{
			
			width: (725px/2);
			position: relative;
			.search-box{
				margin: 10px 20px 0 20px;
				position: relative;
				.search-show-box{
					position: absolute;
					left: 0;
					right: 0;
					top: 100%;
					background-color: white;
					z-index: 100;
					padding: 10px 0;
					box-sizing: border-box;
					.scroll-box{
						font-size: 14px;
						padding: 10px 0px;
						box-sizing: border-box;
						background-color: white;
						.check-box{
							margin-right: 10px;
						}
						.pic-box{
							margin-right: 10px;
							.pic{
								width: 30px;
								height: 30px;
								border-radius: 50%;
								background-color: #409EFF;
								font-size: 12px;
								text-align: center;
								line-height: 30px;
								color: white;
							}
						}
						.name{
							margin-bottom: 5px;
						}
						.job{
							color: #aaaaaa;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							word-break: break-all;
							width: 220px;
						}
					}
				}
				.load{
					font-size: 14px;
					text-align: center;
					padding: 10px 0;
				}
			}
			.breadcrumb,.choose-all{
				display: inline-block;
				width: 100%;
				padding: 20px;
				box-sizing: border-box;
			}
			.choose-scroll{
				.scroll-box{
					font-size: 14px;
					margin: 0 20px 20px 20px;
					box-sizing: border-box;
					.next-box{
						cursor: pointer;
						box-sizing: border-box;
						font-size: 0;
						span{
							color: #a0a1a4;
							font-size: 14px;
							vertical-align: middle;
						}
						i{
							display: inline-block;
							width: 14px;
							height: 14px;
							background: url(./choosePer/btn_next.svg) no-repeat center center;
							background-size: 100% 100%;
							vertical-align: middle;
							margin-left: 10px;
						}
					}
					.check-box{
						margin-right: 10px;
					}
					.pic-box{
						margin-right: 10px;
						.pic{
							width: 30px;
							height: 30px;
							border-radius: 50%;
							background-color: #409EFF;
							font-size: 12px;
							text-align: center;
							line-height: 30px;
							color: white;
						}
					}
					.name{
						margin-bottom: 5px;
					}
					.job{
						color: #aaaaaa;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						word-break: break-all;
						width: 255px;
					}
				}
				.dept-box{
					.dept-name{
						// margin-left: 24px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						word-break: break-all;
						box-sizing: border-box;
						padding-right: 10px;
						position: relative;
						&:after{
							content: '';
							display: block;
							width: 1px;
							height: 100%;
							background-color: #ededed;
							position: absolute;
							right: 0;
							top: 0;
						}
					}
				}
			}
			.previous-next-btn{
				margin: 20px 20px 20px 0;
			}
		}
		.wrap-right{
			width: (725px/2);
			position: relative;
			&::after{
				content: '';
				display: block;
				width: 1px;
				height: 100%;
				background-color: #e8e9ed;
				position: absolute;
				top: 0;
				left: 0;
			}
			.choosed-box{
				.choosed-txt{
					color: #ababab;
					margin: 20px 20px 15px 20px;
				}
				.choosed-show{
					margin: 0 20px 20px 20px;
					.cshow-box{
						width: 48%;
						background-color: #eff2f5;
						border-radius: 5px;
						box-sizing: border-box;
						padding: 8px 12px;
						margin-bottom: 10px;
						.cshow-box-l{
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							word-break: break-all;
							.pername{
								color: #424242;
								margin-bottom: 6px;
							}
							.deptname{
								color: #b5b6b8;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								word-break: break-all;
							}
						}
						&:nth-child(odd){
							float: left;
						}
						&:nth-child(even){
							float: right;
						}
						.del-btn{
							cursor: pointer;
						}
					}
				}
				.choosed-btn-box{
					text-align: right;
					margin: 0 20px;
				}
			}
		}
	}
	</style>
	<style lang="scss">
	.choose-per-dialog{
		.el-dialog__body{
			padding: 0;
		}
		.choose-scroll,.search-show-box{
			.el-checkbox__label{
				display: none;
			}
		}
	}
	.el-breadcrumb,
	.el-breadcrumb__inner {
		cursor: pointer !important;
	}
</style>